import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import React from 'react'

export default function RefillStatusCell({ onClick, value }) {
  return (
    <Text
      textAlign="end"
      variant={
        value === 'Por Confirmar' || value === 'OK' ? 'bodyHyperLink' : 'body1'
      }
      onClick={value === 'Por Confirmar' || value === 'OK' ? onClick : null}
    >
      {value}
    </Text>
  )
}

RefillStatusCell.propTypes = {
  onClick: PropTypes.any,
  value: PropTypes.any,
}
